module.exports = __webpack_public_path__ + "9afb438b4a361c4d8096fc13a3cee87c.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../components/Footer/logos/JG-Logo_Immobilien.jpg
// module id = 960
// module chunks = 0